import * as React from 'react';
import { mountSeasonPreviewBackground, unmountSeasonPreviewBackground, } from './seasonPreviewController';
/** Login/entry baggrund: molo.dk-lignende produkt-smøre bag UI. */
export var SeasonPreviewBackground = function (_a) {
    var seasonCode = _a.seasonCode, className = _a.className, id = _a.id;
    var hostRef = React.useRef(null);
    React.useEffect(function () {
        var host = hostRef.current;
        if (!host) {
            return undefined;
        }
        mountSeasonPreviewBackground(host, seasonCode).catch(function (err) {
            console.warn('[SeasonPreview] background mount failed', err);
        });
        return function () {
            unmountSeasonPreviewBackground();
        };
    }, [seasonCode]);
    return (React.createElement("div", { ref: hostRef, id: id, className: className || 'season-preview-background-host', "aria-hidden": "true" }));
};
//# sourceMappingURL=SeasonPreviewBackground.js.map